"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Disclaimer = exports.Subtotal = exports.Close = exports.AddressText = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _slice = require("@lce/slice");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var AddressText = (0, _styledComponents["default"])(_slice.Text).attrs({
  color: _slice.theme.colors.orange,
  fontSize: 5,
  marginBottom: 0
})(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  font-family: ", ";\n  font-weight: bold;\n  line-height: 1;\n  text-transform: uppercase;\n"], ["\n  font-family: ", ";\n  font-weight: bold;\n  line-height: 1;\n  text-transform: uppercase;\n"])), _slice.theme.fonts.mrEaves);
exports.AddressText = AddressText;
var Close = (0, _styledComponents["default"])(_slice.Button).attrs({
  color: _slice.theme.colors.black,
  fontSize: 4
})(templateObject_2 || (templateObject_2 = (0, _tslib.__makeTemplateObject)(["\n  border: none;\n  font-family: ", ";\n  font-weight: normal;\n  padding: 0;\n  text-transform: uppercase;\n  text-decoration: underline;\n\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n"], ["\n  border: none;\n  font-family: ", ";\n  font-weight: normal;\n  padding: 0;\n  text-transform: uppercase;\n  text-decoration: underline;\n\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n"])), _slice.theme.fonts.roboto, _slice.theme.colors.white, _slice.theme.colors.black);
exports.Close = Close;
var Subtotal = (0, _styledComponents["default"])(_slice.Text).attrs({
  fontSize: 5
})(templateObject_3 || (templateObject_3 = (0, _tslib.__makeTemplateObject)([""], [""])));
exports.Subtotal = Subtotal;
var Disclaimer = (0, _styledComponents["default"])(_slice.Text).attrs({
  color: _slice.theme.colors.grey500,
  fontSize: 3
})(templateObject_4 || (templateObject_4 = (0, _tslib.__makeTemplateObject)([""], [""])));
exports.Disclaimer = Disclaimer;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;